/// <reference path="../_references.ts"/>

module App.Customer {
	import ILocation = App.DispatchService.Location;
	import Customer = App.Customer.Customer;
	import CustomerService = App.Customer.CustomerService;
	import TitleBarService = App.Helpers.TitleBarService;

	export class CustomerCreateController {
		static $inject = ['$log', '$scope', 'Validations', 'States', 'DispatchService', 'CustomerService', 'TitleBarService', 'SelectedCustomer', '$state'];

		location: ILocation[];
		hideLocations: boolean = false;

		constructor(
			private $log: ng.ILogService,
			private $scope: ng.IScope,
			private validation: Validations.Validations,
			private states: App.Helpers.State[],
			private dispatchService: DispatchService.DispatchService,
			private customerService: CustomerService,
			private TitleBarService: TitleBarService,
			private SelectedCustomer: SelectedCustomer,
			public $state: ng.ui.IStateService,
			private model: Customer
		){
			TitleBarService.set('Home');

			this.resetCustomer();
			this.getLocations();
		}

		private resetCustomer(): void {
			this.model = new Customer();
			this.model.addBillingAddress();
			this.model.phone_numbers.push(new PhoneNumber());
			this.model.emails.push(new Email());
		}

		getLocations(): void {
			try {
				this.dispatchService.getLocations().then((response) => {
					this.location = response.data;

					if (this.location.length === 1) {
						this.hideLocations = true;
					}
				});
			} catch(error) {
				this.$log.log('customer-create.controller.js - response data null.')
			}
		}

		private completeModelRequirements(model: Customer): Customer {
			let updatedModel: Customer = angular.copy(model);

			updatedModel.billing_addresses = angular.copy(model.service_addresses);
			updatedModel.service_addresses = angular.copy(model.service_addresses);

			updatedModel.billing_addresses[0].street_two = null;
			updatedModel.service_addresses[0].street_two = null;

			if (angular.isUndefined(model.company_name)) {
				updatedModel.company_name = null;
			}
			updatedModel.rate_type = updatedModel.company_name ? 2 : 1;

			if(this.location.length === 1) {
				updatedModel.service_addresses[0].location = this.location[0];
			}

			return updatedModel;
		}

		public submit(form: ng.IFormController) : void {
			if (form.$valid) {
				let updatedModel = this.completeModelRequirements(this.model);

				this.customerService.create(updatedModel).then((response) => {
					this.resetCustomer();
					form.$setPristine();
					form.$setUntouched();

					this.SelectedCustomer.set(response.data);
					this.$state.go('zipSolutions.home.service-request');
				});
			} else {
				form.$setSubmitted();
			}
		}
	}
}
